import React from "react";
import ProjectDetailCard from "../ProjectDetailCard";

import garuda from "../../../Assets/Projects/website/Garuda.png";
import garuda2 from "../../../Assets/Projects/website/Garuda2.png";
import garuda3 from "../../../Assets/Projects/website/Garuda3.png";
import garuda4 from "../../../Assets/Projects/website/Garuda4.png";
import garuda5 from "../../../Assets/Projects/website/Garuda5.png";
import garuda6 from "../../../Assets/Projects/website/Garuda6.png";

function GarudaAirlines() {
  return (
    <ProjectDetailCard
      title="Garuda Airlines Reservation System"
      image={garuda}
      screenshots={[garuda2, garuda3, garuda4]}
      description="
      Garuda Airlines Reservation System is a web-based airline booking platform developed to simplify the flight reservation process through a modern and user-friendly interface. The system allows users to search available flights, view schedules, manage passenger information, and complete ticket bookings efficiently. It also includes an administrative dashboard for managing flight data, destinations, schedules, and customer reservations, providing a centralized solution for airline operations and booking management.
      "
      technologies={[
        "PHP",
        "CodeIgniter 4",
        "MySQL",
        "Bootstrap 5",
        "JavaScript",
        "HTML5",
        "CSS3",
        "Responsive Design",
        "CRUD System",
        "Git",
      ]}
      github="https://github.com/Rezaananda28"
      demo=""
    >
      {/* Project Gallery */}

      <div className="project-section-card mt-4">
        <h3 className="purple">Project Gallery</h3>

        <div className="gallery-grid">
          <img src={garuda5} alt="gallery1" />
          <img src={garuda6} alt="gallery2" />
          <img src={garuda3} alt="gallery3" />
        </div>
      </div>
    </ProjectDetailCard>
  );
}

export default GarudaAirlines;
